import { makeAutoObservable, runInAction } from "mobx";
import { esgService } from "../services";
import { showToast } from "@/lib/utils/toast";
import { organizationStore } from "@/features/organization";
import { promiseWithMinDelay } from "@/lib/utils/promiseWithMinDelay";

class ESGReportListStore {
  page = 1;
  limit = 10;
  loading = false;
  search = "";
  openDeleteDialog = false;
  deleting = false;

  reports = [];
  totalReports = 0;
  allCount = 0;
  inProgressCount = 0;
  completedCount = 0;
  selectedOrgId = "";
  selectedFramework = "all";
  selectedStatus = "all";
  selectedReportToDelete = null;

  constructor() {
    makeAutoObservable(this);
  }

  setPage = (v) => (this.page = v);
  setLimit = (v) => (this.limit = v);
  setSearch = (v) => (this.search = v);
  setOpenDeleteDialog = (v) => (this.openDeleteDialog = v);
  setSelectedStatus = (v) => (this.selectedStatus = v);

  handleOpenDeleteDialog = (report) => {
    this.selectedReportToDelete = report;
    this.openDeleteDialog = true;
  };

  fetchReportList = async (orgId) => {
    runInAction(() => (this.loading = true));

    const query = {
      page: this.page,
      limit: this.limit,
      search: this.search,
      framework: this.selectedFramework,
      status: this.selectedStatus,
      sortBy: "updatedAt",
      sortOrder: "desc",
    };
    if (orgId) query.orgId = orgId;
    const data = await esgService.getReportList(query);

    runInAction(() => {
      this.reports = data?.reports;
      this.totalReports = data?.pagination?.total;
      this.allCount = data?.allCount;
      this.inProgressCount = data?.inProgressCount;
      this.completedCount = data?.completedCount;
      this.loading = false;
    });
  };

  deleteReport = async (id) => {
    runInAction(() => (this.deleting = true));
    const deletePromise = esgService.deleteReport(id);

    showToast.promise(deletePromise, {
      loading: "Deleting Report",
      success: "Successfully deleted report",
      error: "Failed to delete report",
    });

    const data = await promiseWithMinDelay(deletePromise);

    if (data) {
      const selectedOrgId = organizationStore.selectedId;
      runInAction(() => {
        this.fetchReportList(selectedOrgId);
        this.deleting = false;
        this.openDeleteDialog = false;
      });
    }
    return data;
  };

  duplicateReport = async (id, reportName) => {
    const duplicatePromise = esgService.duplicateReport(id, {
      body: { reportName },
    });

    showToast.promise(duplicatePromise, {
      loading: "Duplicating Report",
      success: "Successfully duplicated report",
      error: "Failed to duplicate report",
    });

    const data = await promiseWithMinDelay(duplicatePromise);

    if (data?.report) {
      runInAction(() => {
        this.reports.unshift(data.report);
      });
    }
    return data;
  };
}

export const esgReportListStore = new ESGReportListStore();
